<template>
  <div class="flex flex-col">

    <div class="grow pointer-events-none" />

      <instant-text v-if='isTextMode'
                     class='pointer-events-auto'
                     :partutil='partutil'
                     :render-tools='renderTools'
                     :transforms-and-source='transformsAndSource'
                     :holder-data='holderData'
                     @close="onClose"
                     @done="mode = 'view'; $emit('change')"
                     @change='$emit("change")'
                     @add-children='onAddChildren($event); $emit("change")'
                     />
      <instant-background v-if='isBackgroundMode'
                     class='pointer-events-auto'
                     :partutil='partutil'
                     :render-tools='renderTools'
                     :transforms-and-source='transformsAndSource'
                     :holder-data='holderData'
                     @clear-layer='onClearLayer'
                     @done="mode = 'view'; $emit('change')"
                     @close="onClose" />
      <!--
    <instant-effects v-if='isEffectsMode'
                     class='pointer-events-auto'
                     :partutil='partutil'
                     :render-tools='renderTools'
                     @close="mode = 'view'"
                     />
      -->

    <unified-add-overlay v-if='shownAtLeastOnce'
                         v-show='isAddMode'
                         class='pointer-events-auto'
                         :render-tools='renderTools'
                         :transforms-and-source='transformsAndSource'
                         :partutil='partutil'
                         :holder-data='holderData'
                         :layers='layers'
                         :selected-layers='selectedLayers'
                         @close='onClose'
                         @add-children='onAddChildren($event); $emit("change")'
                         @done="mode = 'view'; $emit('change')"
                 />

    <div v-if='isShowToolbar' class="h-16 flex flex-row justify-center pbc-z-level-2 pointer-events-auto">
      <div class="grow flex flex-row md:w-64 md:flex-none justify-center pointer-events-auto">
        <!--
        <button v-if='enableTemplateButton' :class='templateMode ? "transparent-button" : "transparent-button"' class="mr-3" @click="onToggleTemplateMode">
          <file-document-outline v-if='enableTemplateButton' :size='32' />
          <p>Template</p>
        </button>
        -->

        <button class="transparent-button" @click="mode = 'add'">
          <plus-circle-outline :size='32' />
          <p>Add</p>
        </button>

        <!--
        <button class="transparent-button ">
          <timeline-clock-outline :size='32' />
          <p>Effects</p>
        </button>
        -->
        <button class="transparent-button" @click='mode = "text"'>
          <format-text :size='32' />
          <p>Text</p>
        </button>

        <button class="transparent-button " @click="mode = 'background'">
          <image-filter-black-white :size='32' />
          <p>Background</p>
        </button>

        <button v-if='isAnimationEnabled' class="transparent-button " @click="$emit('animate')">
          <timeline-clock-outline :size='32' />
          <p>Animate</p>
        </button>
     </div>

      <pbc-button @click='$emit("post")' class="bottom-action-button" :disabled='noTransformsAdded'>
        <p v-if='!nextIsPost' class="my-auto" >Next</p>
        <p v-else class="my-auto" >Preview</p>
        <chevron-right />
      </pbc-button>

    </div>
    <!--<history name='ui--mode' v-model='mode' empty='view' />-->
  </div>
</template>
<script>

import { mapState } from 'vuex';
//import FileDocumentOutline from '@icons/FileDocumentOutline.vue';
//import TextBoxOutline from '@icons/TextBoxOutline.vue';
import ChevronRight from '@icons/ChevronRight.vue';
import InstantText from '@ui/organisms/InstantText.vue';
import InstantEffects from '@ui/organisms/InstantEffects.vue';
import InstantBackground from '@ui/organisms/InstantBackground.vue';
import PlusCircleOutline from '@icons/PlusCircleOutline.vue';
import TimelineClockOutline from '@icons/TimelineClockOutline.vue';
import FormatText from '@icons/FormatText.vue';
import ImageFilterBlackWhite from '@icons/ImageFilterBlackWhite.vue';
import UnifiedAddOverlay from '@ui/organisms/UnifiedAddOverlay.vue';

export default {
  props: {
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    },
    noTransformsAdded: {
      type: Boolean,
      default: false
    },
    selectedLayers: {
      type: Object,
      required: true
    },
    layers: {
      type: Object,
      required: true
    },
    enableTemplateButton: {
      type: Boolean,
      default: false
    },
    nextIsPost: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.$route.params.mode) {
      this.onInitialMode(this.$route.params.mode);
    }
    this.$router.replace({
      query:{
        mode:'view'
      }
    });
  },
  data() {
    return {
      isFirstModeChange: true,
      shownAtLeastOnce: false // this is so that the spritesheet (InstantSpriteSheet) sizes correctly
                              // if we display: none it from the beginning, and you came from the select
                              // page, it remembers the spritesheet, and then all bounds for the spritesheet
                              // images are 0, and dont show. this is a hack to force the first click to 
                              // create the DOM and then afterwards we can toggle display: none
    }
  },
  components: {
    //TextBoxOutline,
    //FileDocumentOutline,
    PlusCircleOutline,
    ChevronRight,
    //TimelineClockOutline,
    FormatText,
    InstantText,
    ImageFilterBlackWhite,
    InstantBackground,
    //InstantEffects,
    UnifiedAddOverlay,
    TimelineClockOutline
  },
  methods: {
    onToggleTemplateMode() {
      this.$emit('toggle-template-mode');
    },
    onClose() {
      if (this.$route.query.overlay) {
        this.$emit("remove-draft");
        this.$router.go(-1)
      } else {
        this.mode = "view";
        this.$emit("change");
      }
    },
    onInitialMode(mode) {
      switch (mode) {
        case "add": this.mode = "add"; break;
        case "text": this.mode = "text"; break;
        case "stickers": this.mode = "stickers"; break;
        case "background": this.mode = "background"; break;
      }
    },
    onClearLayer(layer) {
      this.$emit('clear-layer', layer);
    },
    onAddChildren({newChildren, newParents, newComponents}) {
      this.$emit('add-children', {
        newChildren,
        newParents,
        newComponents
      });

      const transform = newChildren[0];
      if (transform.transform.layer !== 'background') {
        this.$emit('select-children', {
          children:newChildren,
          parents:newParents,
          components:newComponents
        });
      }

    }
  },
  computed: {
    isAddMode() {
      return this.mode === 'add';
    },
    isEffectsMode() {
      return this.mode === 'effects';
    },
    isShowToolbar() {
      return this.mode === 'view';
    },
    isTextMode() {
      return this.mode === 'text';
    },
    isBackgroundMode() {
      return this.mode === 'background';
    },
    mode: {
      get() {
        return this.$route.query.mode || "view";
      },
      set(mode) {
        console.log('mode', mode);
        if (mode !== 'view' || this.isFirstModeChange) {
          console.log('PUSH MODE', mode);
          this.$router.push({
            query:{
              mode
            }
          });
          this.isFirstModeChange = false;
          this.$ana.track({
            eventCategory:'editorMode',
            eventAction:mode
          });
        } else {
          console.log("REPLACE MODE", mode);
          this.$router.replace({
            query:{
              mode
            }
          });
          this.$ana.track({
            eventCategory:'editorMode',
            eventAction:mode
          });
        }
      }
    },
    ...mapState(['templateMode', 'isAnimationEnabled'])
  },
  watch: {
    isAddMode(nv) {
      if (nv) {
        this.shownAtLeastOnce = true;
      }
    },
    isEffectsMode(nv) {
      if (nv) {
        this.$emit("effects");
      }
    }
  }
}
</script>
